import Enum from 'enum'

export default new Enum({
  'ADMIN': 0,
  'SUPER_ADMIN': 1,
  'ACCOUNT_MANAGER': 2
})